import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import isFunction from 'lodash/isFunction';
import NominatedChatPopupContainer from 'components/popups/NominatedChatPopover';
import ProgressBarComponent from 'components/popups/ProgressBar/ProgressBar';
import * as extract from 'extractFromState';
import * as actions from '../../actions';
import * as colors from '../common/colorConstants';
import * as expertTypes from 'constants/expertTypes';
import AlertCircleIcon from 'components/Widgets/AlertCircleIcon/AlertCircleIcon';
import { Wrapper, IncomingChatIcon, InnerIcon, NominatedChatPopupWrapper } from './NewChatAlert.styles';

const NewChatAlert = (props) => {
  const isActiveExpert = props.user.expertType === expertTypes.LIVE;
  const notificationExpiration =
    props.firstNotificationTicket && new Date(props.firstNotificationTicket.nominationExpiresAt);
  const alertIsAvailable = !!props.firstNotificationTicket && isActiveExpert && !props.isAdmin;
  const shouldRenderPopup =
    !!props.firstNotificationTicket &&
    !!props.chatAlertActiveId &&
    props.firstNotificationTicket.ticketId === props.chatAlertActiveId;

  const handleIconClick = () => {
    // returning back to home page in case user is on a different page
    if (props.history && isFunction(props.history.push)) {
      props.history.push('/home');
    }
    props.selectInboxTab('nominated');
    props.selectTicket(props.firstNotificationTicket.ticketId, 'nominated');
    props.setChatAlertActiveId(null);
  };

  const isUpsellTicket =
    alertIsAvailable && !!props.firstNotificationTicket.moreTicketInfo?.humanAndBotBothActiveInChat;

  // TODO: Fix dependency array
  useEffect(() => {
    // automatically open nominated ticket notifications when they arrive
    if (!!props.firstNotificationTicket) {
      props.setChatAlertActiveId(props.firstNotificationTicket.ticketId);
    }
  }, [props.firstNotificationTicket, props.nominatedNotifications.length]); // eslint-disable-line

  return (
    alertIsAvailable && (
      <Wrapper>
        <IncomingChatIcon
          onMouseEnter={() => props.setChatAlertActiveId(props.firstNotificationTicket.ticketId)}
          onClick={() => handleIconClick()}
        >
          <InnerIcon>
            New
            <AlertCircleIcon
              count={props.nominatedNotifications.length}
              color={colors.darkGray2}
              isUpsellTicket={isUpsellTicket}
            />
          </InnerIcon>
          {!!notificationExpiration && <ProgressBarComponent expiration={notificationExpiration} />}
        </IncomingChatIcon>

        {shouldRenderPopup && (
          <NominatedChatPopupWrapper>
            <NominatedChatPopupContainer ticket={props.firstNotificationTicket} />
          </NominatedChatPopupWrapper>
        )}
      </Wrapper>
    )
  );
};

NewChatAlert.propTypes = {
  isAdmin: PropTypes.bool.isRequired,
  unreadNominatedTicketIds: PropTypes.arrayOf(PropTypes.string),
  user: PropTypes.object.isRequired,
  firstNotificationTicket: PropTypes.object,
  chatAlertActiveId: PropTypes.string,
  nominatedNotifications: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => ({
  isAdmin: extract.isSpecialist(state),
  unreadNominatedTicketIds: state.unreadNominatedTicketIds,
  user: state.user,
  firstNotificationTicket: extract.extractFirstNominatedNotification(state),
  nominatedNotifications: extract.extractNominatedNotifications(state),
  chatAlertActiveId: extract.getChatAlertActiveId(state),
});

const mapDispatchToProps = {
  setChatAlertActiveId: actions.setChatAlertActiveId,
  selectTicket: actions.selectTicket,
  selectInboxTab: actions.selectInboxTab,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewChatAlert));
